import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ONBOARDING_ELIGIBILITY_QUESTIONS } from "../../../constants/onboardingEligibilityQuestions";
import { Form, Select } from "../../../components/forms";
import EligibilityForm from "../../../components/eligibilityForm/EligibilityForm";
import EligibilityFormElements from "../eligibility/EligibilityFormElements";
import classNames from "classnames";
import ViewTestimonialsDrawer from "./ViewTestimonialsDrawer";
import { GPS_URL } from "../../../constants";
import DatePickerInput from "./DatePickerInput";
import dayjs from "dayjs";
import {
  useUpdateHubSpotMutation
} from "../../../services/dataService"

const EligibilityCheckForm = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [activeInfoCard, setActiveInfoCard] = useState([]);
  const [firstSubmit, setFirstSubmit] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState();
  const [condition, setCondition] = useState();
  const [disable, setDisable] = useState(true);
  const today = new Date();
  const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  const currentYear = new Date().getFullYear();
  const minDate = new Date(currentYear - 80, 0, 1); 
  const maxDate = new Date(currentYear, 11, 31);
  const [updateHubSpot] = useUpdateHubSpotMutation();

  const handleDateChange = (event) => {
    setDateOfBirth(dayjs(event).format('YYYY-MM-DD'));
  };

  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };

  const { q1, q4, q5 } = ONBOARDING_ELIGIBILITY_QUESTIONS.data;

  const handleNavigate = (values) => {
    const q1Answer = values.q1;
    const q4Answer = values.q4;
    const q5Answer = values.q5;

    if (q4Answer === q4.answers[0].id && q5Answer === q5.answers[1].id) {
      if (dateOfBirth <= dayjs(eighteenYearsAgo).format('YYYY-MM-DD')) {
        navigate("/onboarding/eligibility-flow/eligibility-success");
      } else {
        navigate("/onboarding/eligibility-flow/eligibility-age-error");
      }
    } else {
      navigate("/onboarding/eligibility-flow/eligibility-error");
    }
  };

  const handleOnBack = () => {
    navigate("/onboarding/eligibility-flow/condition");
  };

  const handleAnswerClick = (questionId, answerId) => {
    const isSecondAnswer =
      (questionId === q1.id && answerId === q1.answers[1].id) ||
      (questionId === q4.id && answerId === q4.answers[1].id) ||
      (questionId === q5.id && answerId === q5.answers[0].id);

    if (isSecondAnswer) {
      setActiveInfoCard((prev) => [...prev, questionId]);
    } else {
      const updatedActiveList = activeInfoCard.filter(
        (question) => question !== questionId
      );
      setActiveInfoCard(updatedActiveList);
    }

    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: answerId,
    }));
  };

  const savedValues = JSON.parse(
    localStorage.getItem("EligibilityForm") || "null"
  );

  const savedCondition = savedValues?.["What primary condition are you seeking treatment for?"];
  const initialValues = {
    [q1.id]:
      q1.answers.find((ans) => ans.label === savedValues?.[q1.title])?.id || "",
    [q4.id]:
      q4.answers.find((ans) => ans.label === savedValues?.[q4.title])?.id || "",
    [q5.id]:
      q5.answers.find((ans) => ans.label === savedValues?.[q5.title])?.id || "",
    ...(savedCondition ? { condition: savedCondition } : {}),
  };

  const handleSubmit = async (values) => {
    setFirstSubmit(true)
    if (!dateOfBirth) {
      return;
    }
    const objectData = {
      [q4.title]: q4.answers.find((ans) => ans.id === values.q4).label,
      [q5.title]: q5.answers.find((ans) => ans.id === values.q5).label,
      "What primary condition are you seeking treatment for?": values.condition,
      "Date of birth": dateOfBirth
    };
    const data = JSON.stringify({ ...savedValues, ...objectData });
    localStorage.setItem("EligibilityForm", data);
    await submitHubSpot(values);
    handleNavigate(values);
  };

  const submitHubSpot = async (values) => {
    const vid = localStorage.getItem("vid")
    try {
      let data = {
        properties: [
          {
            property: "dob",
            value: dateOfBirth
          },
          {
            property: "eligibility_q1",
            value: q4.answers.find((ans) => ans.id === values.q4).label
          },
          {
            property: "eligibility_q2",
            value: q5.answers.find((ans) => ans.id === values.q5).label
          },
          {
            property: "selected_condition",
            value: values.condition
          },
        ]
      };
      const updateRes = vid && await updateHubSpot({ values: data, vid: vid })

      if (updateRes.data.status === "Success") {
      } else {
        console.error("hubspot faild")
      }
    } catch (error) {
      console.error(error);
    }
  }

  const InfoCard = ({ title, description, imageSrc }) => (
    <div className="bg-transparent px-4 py-3 mt-3 mt-md-4 mt-lg-5 border rounded">
      <div className="d-flex flex-row align-items-start align-items-lg-center gap-0 mb-2 infocard-title">
        {imageSrc && (
          <img src={imageSrc} className="info-icon me-2" alt="" />
        )}
        <p className="mb-0 mt-1 mt-lg-0">{title}</p>
      </div>
      <p className="text-dark-4 mb-0 infocard-text">{description}</p>
    </div>
  );

  const navigateToGpService = () => {
    window.open(`${GPS_URL}/docnow/`);
  };

  useEffect(() => {
    setDateOfBirth(savedValues?.["Date of birth"] && dayjs(savedValues?.["Date of birth"]).format('YYYY-MM-DD'))
  }, [savedValues?.["Date of birth"]])

  // useEffect(() => {
  //   if (!localStorage.getItem("isOtpVerified"))
  //     handleOnBack()
  // }, [])

  useEffect(() => {
    if (initialValues["q4"] !== "") {
      setDisable(false)
    } else {
      const isDisabled =
        !dateOfBirth ||
        dateOfBirth > dayjs(eighteenYearsAgo).format('YYYY-MM-DD') ||
        !condition ||
        Object.keys(selectedAnswers).length < 2

      setDisable(isDisabled)
    }
  }, [dateOfBirth, condition, selectedAnswers])

  return (
    <div className="d-flex flex-column h-100 justify-content-between">
      <h4 className="mb-2 fw-bold">
        Let's check if your eligible for medical cannabis treatment
      </h4>
      <p className="text-gray-1 mb-3">
        To get started with a free eligibility check enter the details below
      </p>
      <div className="d-flex mt-4 h-100">
        <Form
          initialValues={initialValues}
          onSubmit={(values) => {
            dateOfBirth && (dateOfBirth <= dayjs(eighteenYearsAgo).format('YYYY-MM-DD')) && handleSubmit(values)
          }}
          enableReinitialize
          className="d-flex flex-column justify-content-between"
        >
          <div className="mb-12 mb-md-0">
            <div className="col-md-12 col-lg-6 mb-5">
              <label className="mb-2">
                1. Enter your date of birth<span className="text-red-1">*</span>
              </label>
              <DatePickerInput
                name="dateOfBirth"
                onChange={handleDateChange}
                defaultValue={dateOfBirth && new Date(dateOfBirth)}
                minDate={minDate}
                maxDate={maxDate}
              />
              {dateOfBirth === undefined && firstSubmit && (
                <label className="text-danger mt-1">
                  Date of birth is required
                </label>
              )}
              {dateOfBirth > dayjs(eighteenYearsAgo).format('YYYY-MM-DD') && firstSubmit && (
                <label className="text-danger mt-1">
                  Age Should be at least 18 years old
                </label>
              )}
            </div>
            <ol className="" style={{ listStyleType: "none", paddingLeft: "0" }}>
              {[q4, q5].map((question, index) => (
                <li key={question.id}>
                  <label className="mb-2 listContent">
                    {index + 2 + ". "}{question.title}
                    <span className="text-red-1">*</span>
                  </label>
                  <div className="d-flex flex-column answer-box mt-1 mb-5 w-100">
                    <EligibilityForm
                      condition={
                        question.conditionType.includes("info")
                          ? question.condition
                          : []
                      }
                      field={
                        question.conditionType.includes("info")
                          ? question.id
                          : ""
                      }
                      infoText={
                        question.conditionType.includes("info")
                          ? question.infoText
                          : ""
                      }
                    >
                      <EligibilityFormElements
                        answers={question.answers}
                        condition={
                          question.conditionType.includes("field")
                            ? question.condition
                            : []
                        }
                        name={question.id}
                        onChange={(questionId, answerId) => {
                          handleAnswerClick(questionId, answerId);
                        }}
                        isEligibility={true}
                        elementClass="d-flex flex-column w-100"
                        innerClass={classNames({
                          "d-flex flex-column flex-lg-row gap-4 gap-md-4 answer-box-sm":
                            question.id === q1.id,
                          "d-flex flex-row gap-4": question.id !== q1.id,
                        })}
                        errorClass="error-text mt-1"
                      />
                    </EligibilityForm>
                    {firstSubmit && !selectedAnswers[question.id] && (
                      <label className="text-danger mt-1">
                        Please answer the question to continue
                      </label>
                    )}
                  </div>
                </li>
              ))}
            </ol>
            <div className="row">
              <div className="col-md-12 col-lg-6 d-flex flex-column">
                <label className="mb-2">
                  4. What primary condition are you seeking treatment for?
                  <span className="text-red-1">*</span>
                </label>
                <Select
                  name="condition"
                  placeholder="Select your condition"
                  className="form-select shadow-none py-2 bg-transparent border card-border fs-6 rounded pe-2 w-100 custom-placeholder"
                  errorClass="error-text mt-1"
                  options={[
                    { value: "pain", label: "Pain" },
                    { value: "cancer", label: "Cancer Related Symptoms" },
                    { value: "mentalHealth", label: "Mental Health" },
                  ]}
                  onChange={(e) => setCondition(e.target.value)}
                />
                {condition === undefined && firstSubmit && (
                  <label className="text-danger mt-1">
                    Please select a condition
                  </label>
                )}
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-10 px-0 py-0 mb-md-5 mb-lg-0">
                  {activeInfoCard[activeInfoCard.length - 1] === q1.id && (
                    <InfoCard
                      title="Sorry, we are unable to proceed further."
                      description="If you are under 18 and experiencing pain, we understand the importance of seeking medical support. Unfortunately, we cannot provide consultations to those under 18."
                      imageSrc="/images/vectors/danger-primary.svg"
                    />
                  )}
                  {activeInfoCard[activeInfoCard.length - 1] === q4.id && (
                    <>
                      <InfoCard
                        title="Sorry, we are unable to proceed further."
                        description="We regret to inform you that we are unable to prescribe medical cannabis if you haven’t tried out at least two treatments or procedures for your condition."
                        imageSrc="/images/vectors/danger-primary.svg"
                      />
                      <div className="prescription-box px-4 py-3 border-0 rounded w-fit mt-4">
                        <img
                          src="/images/eligibility/gps-logo.png"
                          alt="GPS logo"
                          className="gps-logo-img"
                        />
                        <p className="mb-0 mt-1">
                          You can now get your prescriptions through the GP
                          service.{" "}
                          <span
                            className="text-green-1 fw-bold cursor-pointer"
                            onClick={navigateToGpService}
                          >
                            Visit now
                          </span>
                        </p>
                      </div>
                    </>
                  )}
                  {activeInfoCard[activeInfoCard.length - 1] === q5.id && (
                    <InfoCard
                      title="We regret to inform you that we are unable to prescribe medical cannabis if you are experiencing schizophrenia / Schizoaffective disorder or psychosis."
                      description="We appreciate your understanding. If you require any additional information or believe that you are still eligible, please don't hesitate to reach out to us. Our team is always here to assist you."
                      imageSrc="/images/vectors/danger-primary.svg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="column d-flex flex-row justify-content-center justify-content-md-end align-items-center">
            <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0 fixed-single-footer justify-content-md-end">
              <button
                className="d-none d-md-block text-primary-600 bg-transparent py-2 px-4 btn-sm w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
                onClick={handleOnBack}
                type="button"
              >
                <p className="mb-0 fw-bold fs-6">Back</p>
              </button>
              <button
                className="d-block d-md-none text-primary-600 bg-transparent pt-2 pb-0 px-4 w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
                type="button"
                onClick={toggleModal}
              >
                <p className="mb-0 fw-bold fs-6">
                  View testimonials
                </p>
              </button>
              <button
                className={
                  `bg-primary-600 text-white py-2 px-5 btn-sm w-md-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap
                  ${disable ? "opacity-50" : "opacity-100"}
                  `}
                type="submit"
                onClick={() => setFirstSubmit(true)}
              >
                Continue
              </button>
            </div>
          </div>
        </Form>
      </div>
      <ViewTestimonialsDrawer show={showModal} onClose={toggleModal} />
    </div>
  );
};

export default EligibilityCheckForm;
